var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCvAttr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.156,
    height: 14,
    viewBox: "0 0 11.156 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#aaa;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M289.137,60.133l-9.681-4.347a.221.221,0,0,0-.027-.007.727.727,0,0,0-.3-.076l-.012,0h-.007a.717.717,0,0,0-.328.092c-.012.006-.028,0-.039.011s-.027.032-.042.044a.712.712,0,0,0-.173.178.614.614,0,0,0-.05.075.7.7,0,0,0-.086.325V68.974a.727.727,0,0,0,1.453,0v-3.36l9.315-4.185a.727.727,0,0,0-.019-1.3Zm-2,.652-7.294,3.2v-6.4Z",
    transform: "translate(-278.388 -55.7)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvAttr);
export default __webpack_public_path__ + "static/media/cv_attr.3d9f2a48.svg";
export { ForwardRef as ReactComponent };